import env from '@y2/environments';

export const YAD2_TREEDIS_URL = env.routes.treedis;

export const PROJECTS_PER_FEED = 18;
